import { trackEvent, trackPageview } from "@garantidos/utils/tracking"

const pageview = (hashedCpf, proposalId) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/env-proposta/envio-proposta-sucesso",
    hashedCpf,
    implementationTeam: "cgi:v01"
  }

  const ga = {
    label: "IT:NL:NCC:CGI:EnviodePropostacomSucessoRV",
    hashedCpf,
    proposalId: proposalId
  }

  trackPageview({ ga, ga4 })
}

const backHome = (hashedCpf) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/env-proposta/envio-proposta-sucesso",
    hashedCpf,
    implementationTeam: "cgi:v01",
    detail: "envio-proposta-sucesso-voltar-inicio",
    eventName: "click"
  }
  trackEvent({ ga4 })
}

const proposal = (hashedCpf, proposalId) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/env-proposta/envio-proposta-sucesso",
    hashedCpf,
    implementationTeam: "cgi:v01",
    proposalId: proposalId.toString(),
    eventName: "proposal"
  }

  trackPageview({ ga4 })
}

export { pageview, backHome, proposal }
